interface RenderHtmlParams {
    content: string
    position: string
    animation: string
    overlay: boolean
    maxWidth: number
    borderRadius: number
}

const positionCss: Record<string, string> = {
    center: 'align-items:center;justify-content:center;',
    bottom_right: 'align-items:flex-end;justify-content:flex-end;',
    bottom_left: 'align-items:flex-end;justify-content:flex-start;',
    top_bar: 'align-items:flex-start;justify-content:center;',
    full_screen: 'align-items:stretch;justify-content:stretch;',
}

const animationKeyframes: Record<string, string> = {
    none: '',
    fade: '@keyframes pvFadeIn{from{opacity:0}to{opacity:1}}',
    slide_up: [
        '@keyframes pvFadeIn{from{opacity:0}to{opacity:1}}',
        '@keyframes pvSlideUp{from{transform:translateY(100dvh);opacity:0}to{transform:translateY(0);opacity:1}}',
    ].join('\n'),
    scale: [
        '@keyframes pvFadeIn{from{opacity:0}to{opacity:1}}',
        '@keyframes pvScale{from{transform:scale(.9);opacity:0}to{transform:scale(1);opacity:1}}',
    ].join('\n'),
}

const wrapperAnimation: Record<string, string> = {
    none: '',
    fade: 'animation:pvFadeIn .3s ease-out forwards;opacity:0;',
    slide_up: 'animation:pvSlideUp .3s ease-out forwards;transform:translateY(100dvh);opacity:0;',
    scale: 'animation:pvScale .3s ease-out forwards;transform:scale(.9);opacity:0;',
}

const closeActionScript = `<script>
document.addEventListener('click',function(e){
var target=e.target.closest&&e.target.closest('[data-action="close"]');if(!target)return;
e.preventDefault();
if(typeof window.dismiss==='function'){window.dismiss()}else{location.href='postles://dismiss'}
})
</script>`

export function renderPopupHtml({ content, position, animation, overlay, maxWidth, borderRadius }: RenderHtmlParams): string {
    const isFullScreen = position === 'full_screen'
    const isTopBar = position === 'top_bar'
    const popupBorderRadius = isFullScreen || isTopBar ? 0 : borderRadius
    const popupMaxWidth = isFullScreen ? '100%' : `${maxWidth}px`
    const popupMargin = isFullScreen || isTopBar ? '0' : '20px'
    const popupMaxHeight = isFullScreen ? '100dvh' : 'calc(100dvh - 40px)'

    return `<!DOCTYPE html>
<html><head><meta charset="utf-8">
<meta name="viewport" content="viewport-fit=cover,width=device-width,initial-scale=1.0,user-scalable=no"/>
<style>
*{box-sizing:border-box;margin:0;padding:0}
*{user-select:none;-webkit-user-select:none}
body{background:${overlay ? 'rgba(0,0,0,0.4)' : 'transparent'};overflow:hidden}
img{max-width:100%;height:auto}
a{color:inherit;text-decoration:none}
.pv-rich-text a{text-decoration:underline}
.pv-rich-text ul,.pv-rich-text ol{display:inline-block;text-align:left;padding-left:1.5em}
.pv-wrapper{display:flex;${positionCss[position] ?? positionCss.center}overflow:scroll;position:fixed;inset:0;padding-bottom:env(safe-area-inset-bottom);max-height:100%;${wrapperAnimation[animation] ?? ''}}
.pv-wrapper::-webkit-scrollbar{display:none}
.pv-popup{width:100%;max-width:${popupMaxWidth};${isFullScreen ? 'height:100%;' : ''}border-radius:${popupBorderRadius}px;overflow:hidden scroll;box-shadow:${isFullScreen ? 'none' : '0 8px 32px rgba(0,0,0,0.2)'};margin:${popupMargin};max-height:${popupMaxHeight};-webkit-overflow-scrolling:touch;position:relative}${isFullScreen ? '\n.pv-popup>div{min-height:100%}' : ''}
${animationKeyframes[animation] ?? ''}
</style>
</head><body>
<div class="pv-wrapper">
<div class="pv-popup">
${content}
</div>
</div>
${content.includes('data-action="close"') ? closeActionScript : ''}
</body></html>`
}
